import React, { ReactNode } from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import { useAppSelector } from 'store/hook';

const BreadcrumbLabel = styled.div`
  font-size: 14px;
`;

const RightSlot = styled.div`
  align-self: flex-end;
  padding-bottom: 6px;
  margin-right: 10px;
`;

type Props = {
  rightSlot?: ReactNode;
};

const CommunityAIOverviewHeader = ({ rightSlot }: Props) => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  return (
    <div data-test-id="community-ai-overview-header">
      <Header
        title={selectedCommunity?.name || ''}
        breadcrumbs={
          <BreadcrumbLabel data-test-id="community-ai-overview-header-community-name">My Community</BreadcrumbLabel>
        }
      >
        {rightSlot && <RightSlot>{rightSlot}</RightSlot>}
      </Header>
    </div>
  );
};

export default CommunityAIOverviewHeader;
